import { render, staticRenderFns } from "./researchProjects.vue?vue&type=template&id=8bdd0d82&scoped=true&"
import script from "./researchProjects.vue?vue&type=script&lang=js&"
export * from "./researchProjects.vue?vue&type=script&lang=js&"
import style0 from "./researchProjects.vue?vue&type=style&index=0&id=8bdd0d82&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdd0d82",
  null
  
)

export default component.exports